import { DataField } from "@iventis/domain-model/model/dataField";

/*
    DATA FIELD HELPERS FOR DISCIPLINE SCHEDULES AND STATIC SESSION FORM
*/

// Simple list of all data fields, except those with metadata
export enum SportEventDataFieldNames {
    DISCIPLINE = "Discipline",
    SESSION_TYPE = "Session type",
    SESSION_STYLE = "Session style",
    MEDAL_TYPE = "Medal type",
    VENUE_CODE = "Venue code",
    TICKETED = "Ticketed",
    MEDAL_CEREMONY = "Medal ceremony",
}

export const NoMedalType = "No medal";

export const getSportsFilterableDataFields = (dataFields: DataField[]): DataField[] =>
    dataFields.filter((dataField) => filterableDataFields.includes(dataField.name as SportEventDataFieldNames));

const filterableDataFields = [SportEventDataFieldNames.DISCIPLINE];

/*
    DATA FIELD GETTERS
*/
export const getDataField = (dataFields: DataField[], dataFieldName: SportEventDataFieldNames) => dataFields.find((df) => df.name === dataFieldName);

export const getDisciplineDataField = (dataFields: DataField[]): DataField => getDataField(dataFields, SportEventDataFieldNames.DISCIPLINE);
